var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-pad"},[_c('canvas',{ref:"canvas",staticClass:"signature-pad-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }